export default __webpack_public_path__ + "static/media/T&CBG.16cb3017.svg";